/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents } from '@gh/builder-shared-data';
import { ActionFlow, getRouteInitData } from '@gh/common-shared';
import { ReportRohcDetails, ReportRohcDetailsTab } from '../../resources/report-roch-details.model';
import { ReportRohcDetailsCommandService } from './report-rohc-details-command.service';
import { ReportRohcDetailsFormState } from './report-rohc-details-form.service';

@Component({
  selector: 'gh-report-rohc-details',
  template: require('./report-rohc-details.component.html'),
  providers: [
    ReportRohcDetailsFormState,
    ReportRohcDetailsCommandService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportRohcDetailsComponent extends AbstractFormComponent<ReportRohcDetails> implements OnInit {
  constructor(private route: ActivatedRoute,
              private userContext: BuilderUserContext,
              private navigations: BuilderNavigationService,
              private commands: ReportRohcDetailsCommandService,
              public form: ReportRohcDetailsFormState) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<ReportRohcDetails>> {
    return this.commands.completeFlow;
  }

  ngOnInit(): void {
    const { details } = getRouteInitData(this.route);

    this.commands.build(details);
  }

  onSelectedTabChange(tab: ReportRohcDetailsTab): void {
    this.commands.selectTab(tab);
  }

  goToAel(): void {
    this.navigations.goToAel({
      label: 'lbl_regional_office_house_cost',
      entityType: this.userContext.masterView ? 'MASTER_ZONE' : void 0,
      // tslint:disable-next-line:no-non-null-assertion
      entityId: this.userContext.masterView ? this.userContext.masterZone!.id : void 0,
      eventTypeIds: [AelEvents.Reports.Rohc.Edited],
    });
  }

  onReset(): void {
    this.commands.reset();
  }
}
